const LOCALES = require("../config").LOCALES;

const translationsMap = {};
Object.keys(LOCALES).forEach(localeKey => {
  const locale = LOCALES[localeKey];
  translationsMap[locale] = require(`./en_US.json`);
});

export default translationsMap;
